.editor {
  height: 100%;
}

// Doubled so Habla's own rule cannot win on emit order.
.textArea.textArea {
  padding: var(--dixa-size-spacer-250);
  padding-bottom: var(--dixa-size-spacer-200);
  min-height: 150px;
}

.stateBar {
  position: relative;
  justify-content: start;
  top: 0;
  right: 0;
}
